import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  searchPlaceholder: {
    id: 'humwF2',
    defaultMessage: 'Enter order number to preview',
    description: 'Placeholder text for the order number search input in the HTML template editor',
  },
  searchButton: {
    id: 'wDOxZ3',
    defaultMessage: 'Search',
    description: 'Aria label for the search button in the order number search input',
  },
  noResultsError: {
    id: 'ymNdyg',
    defaultMessage: 'No orders found for "{orderNumber}"',
    description: 'Error message when no orders match the searched order number',
  },
  searchError: {
    id: 'SybYYI',
    defaultMessage: 'Failed to search for orders. Please try again.',
    description: 'Error message when the order search API call fails',
  },
  clearSelection: {
    id: 'WMRJTb',
    defaultMessage: 'Clear selection',
    description: 'Aria label for the button to clear the selected order',
  },
  selectOrderTitle: {
    id: 'PGLJ3K',
    defaultMessage: 'Select order',
    description: 'Title for the order selection modal when multiple orders match',
  },
  selectOrderBody: {
    id: 'hNr9wb',
    defaultMessage: 'Multiple orders match "{orderNumber}". Please select one:',
    description: 'Body text for the order selection modal',
  },
  selectShipmentBody: {
    id: 'yxWEyb',
    defaultMessage: 'This order has multiple shipments. Please select one:',
    description: 'Body text for the shipment selection modal',
  },
  continueButton: {
    id: 'lNSjY3',
    defaultMessage: 'Continue',
    description: 'Continue button in the order/shipment selection modal',
  },
  cancelButton: {
    id: '68A6UL',
    defaultMessage: 'Cancel',
    description: 'Cancel button in the order/shipment selection modal',
  },
  itemCount: {
    id: 'hfH58u',
    defaultMessage: '{count, plural, one {# item} other {# items}}',
    description: 'Item count with proper singular/plural handling',
  },
  itemCountWithStatus: {
    id: 'YOoFQ8',
    defaultMessage: '{count, plural, one {# item} other {# items}} — {status}',
    description: 'Item count with status, using proper singular/plural handling',
  },
});
